import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { VehicleDeviation } from '../../models/vehicle/vehicle-deviation';
import { TranslateModule } from '@ngx-translate/core';
import { NgStyle } from '@angular/common';

@Component({
    selector: 'app-deviation-text',
    templateUrl: './deviation-text.component.html',
    styleUrls: ['./deviation-text.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgStyle, TranslateModule]
})
export class DeviationTextComponent {

    @Input() deviation: VehicleDeviation;

    constructor() { }

}
